import { render, staticRenderFns } from "./expertInfoMaintenance.vue?vue&type=template&id=bc4824b0&scoped=true"
import script from "./expertInfoMaintenance.vue?vue&type=script&lang=js"
export * from "./expertInfoMaintenance.vue?vue&type=script&lang=js"
import style0 from "./expertInfoMaintenance.vue?vue&type=style&index=0&id=bc4824b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4824b0",
  null
  
)

export default component.exports